export class BreadCrumbModel {
  label: string;
  routerLink: any;
}
